import React from 'react';
import { Provider } from 'react-redux';
import { store } from './Redux/store';
import RootOverlay from './Components/RootOverlay';
import { initialState as userReducerInitialState } from './Redux/Reducers/userReducers';
import { initialState as generalReducerInitialState } from './Redux/Reducers/generalReducers';
import RootNavigator from './Navigation/RootNavigator';
import BrandProvider from './Components/shared/BrandProvider';
import './App.css';
// import { PersistGate } from 'redux-persist/integration/react';
// import RootLoaderGate from './Navigation/RootLoaderGet';
// import AppPropsInterface from './Objects/interfaces/AppPropsInterface';

export default class App extends React.Component {
   
  
  render() {
   
    return (
      <>
        <Provider store={store}>
          <BrandProvider>
            {/* <PersistGate loading={null} persistor={persistor}> */}
                <RootNavigator  {...{ user: userReducerInitialState, general: generalReducerInitialState, dispatch: store.dispatch }} />
                <RootOverlay {...{ user: userReducerInitialState, general: generalReducerInitialState, dispatch: store.dispatch }} />
            {/* </PersistGate> */}
          </BrandProvider>
        </Provider>
      </>
    );
  }
}
